import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { RootState } from 'af-reducers';

import EquipmentGroup from './EquipmentGroup';

interface OwnProps {
	dueDate: string;
	isDragAndDropDisabled: boolean;
	hasPermissionsToEditScheduleBoard: boolean;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const LoanedEquipment: React.FC<Props> = (props) => {
	const {
		dueDate,
		equipmentStatuses = [],
		isDragAndDropDisabled,
		hasPermissionsToEditScheduleBoard,
		showSection,
	} = props;

	if (!showSection || !equipmentStatuses?.length) {
		return null;
	}

	return (
		<div className="schedule-board-toolbar-equipment-row">
			<label>Loaned Equipment</label>
			{
				equipmentStatuses.map(({ id: _eqStatusId, title: _eqStatus }) =>
				(
					<div className="schedule-board-toolbar-equipment-wrapper available" key={_eqStatusId}>
						<div className="schedule-board-toolbar-equipment available">
							<EquipmentGroup
								availabilityLabel="loaned"
								dueDate={dueDate}
								groupId={_eqStatusId}
								groupTitle={_eqStatus}
								hasPermissionsToEditScheduleBoard={hasPermissionsToEditScheduleBoard}
								hasReason={false}
								isDeleted={true}
								isDragAndDropDisabled={isDragAndDropDisabled}
							/>
						</div>
					</div>
				))
			}
		</div>
	);
};

function mapStateToProps(state: RootState, props: OwnProps) {
	const { dueDate } = props;
	const { workOrdersByDateDictionary } = state.scheduleBoard;

	const loanedEquipment = workOrdersByDateDictionary[dueDate]?.toolbarEquipment.loaned ?? {};
	const showSection = Object.keys(loanedEquipment).length > 0;
	return {
		showSection,
		equipmentStatuses: state?.scheduleBoard?.toolbarEquipmentGroupTitles?.loaned,
	};
}

const connector = connect(mapStateToProps);

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(LoanedEquipment);
